import { put, takeEvery } from 'redux-saga/effects';

import {
  DETAILS_EMAIL_CHANGE,
  DETAILS_EMAIL_BLURRED,
  DETAILS_EMAIL_FOCUSED,
  accountEmailSet,
  accountEmailSetFocus,
  accountEmailSetVisualization
} from 'src/app/redux/actions/registration/account/accountFormEmail';



function* accountEmailFocus() {
  yield put(accountEmailSetFocus(true));
}

function* accountEmailBlur({ payload }) {
  const { markedAsWrong, validationMessage } = payload;

  yield put(accountEmailSetFocus(false));

  if (!markedAsWrong) {
    yield put(accountEmailSetVisualization(!!validationMessage));
  }
}

function* accountEmailChange({ payload }) {
  const { value, markedAsWrong, apiError, validationMessage } = payload;

  yield put(accountEmailSet(value));

  if (markedAsWrong || apiError) {
    yield put(accountEmailSetVisualization(!!validationMessage));
  }
}


export { accountEmailFocus, accountEmailBlur, accountEmailChange };

export default [
  takeEvery(DETAILS_EMAIL_CHANGE, accountEmailChange),
  takeEvery(DETAILS_EMAIL_FOCUSED, accountEmailFocus),
  takeEvery(DETAILS_EMAIL_BLURRED, accountEmailBlur)
];

